import { render } from "./EndOrder.vue?vue&type=template&id=53b7e664&scoped=true"
import script from "./EndOrder.vue?vue&type=script&lang=js"
export * from "./EndOrder.vue?vue&type=script&lang=js"

import "./EndOrder.vue?vue&type=style&index=0&id=53b7e664&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b7e664"]])

export default __exports__